export let priceItemProps = {
    key: 0,
    id: 0,
    tailoring_item_sub_category_id: null,
    price: 0
}

export let dataProps = {
    id: 0,
    price_category_name: '', 
    price_category_list: [JSON.parse(JSON.stringify(priceItemProps))],
}


// WEBPACK FOOTER //
// ./src/store/modules/fabricPriceSlab/properties.js